import axios from 'axios';
import * as types from './types';

const actions = {
  [types.GET_RANDOMIZE_RECIPE](context, { isEmbroideryApplied, model }) {
    let requestUrl = `${ this.state.endPoints.customizer.randomize }/${ model }`;
    requestUrl += `?isEmbroideryApplied=${ isEmbroideryApplied }`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: 'GET',
        headers: { 'content-type': 'application/json' },
      })
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  }
};

export default actions;
